export const CATERING_CHILD_ROUTES = [
  '/catering/estimator',
  '/catering/food-items',
  '/catering/rations',
  '/catering/estimates',
];

/** Flat flyout links for the Catering sidebar row (Administration → Catering ›). */
export function buildCateringFlyoutItems(hasMenuAccess) {
  return [
    hasMenuAccess('/catering/estimator') ? { label: 'Cost Estimator', path: '/catering/estimator' } : null,
    hasMenuAccess('/catering/food-items') ? { label: 'Food Items', path: '/catering/food-items' } : null,
    hasMenuAccess('/catering/rations') ? { label: 'Ration Templates', path: '/catering/rations' } : null,
    hasMenuAccess('/catering/estimates') ? { label: 'Saved Estimates', path: '/catering/estimates' } : null,
  ].filter(Boolean);
}
